<template>
  <div class="flex-container d-flex flex-column about">
    <div v-if="isMobile" class="mobile-top-nav header-2">About</div>
    <div
      v-if="!isMobile"
      class="relative flex-container d-flex flex-column ai-center bg-dark"
    >
      <div class="mg-150" />

      <div class="section-wrapper d-flex flex-column mg-150 color-white">
        <div class="header-2">About</div>
        <div class="text-1 mg-50 opaque">
          저희는 기업의 크고 작음에 관계없이,
          <br />국내 모든 기업들이 객관적인 데이터를 통해 의사결정을 할 수
          있도록 <br />데이터 전 주기에 대하여 컨설팅을 제공하는 연구 중심의
          회사입니다.
        </div>
        <div class="mg-150" />
      </div>
    </div>
    <Vision />
    <History />
    <News />
  </div>
</template>

<script>
import Vision from "../components/Vision.vue";
import History from "../components/History.vue";
import News from "../components/News.vue";

export default {
  components: {
    Vision,
    History,
    News,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
};
</script>

<style scoped>
.about {
  overflow-y: hidden;
}
</style>
